import React from 'react';
import { Navigate } from 'react-router-dom';
import { PlayerProfilePage } from '../../pages/playerProfile/playerProfilePage';
import { OrgLayout } from '../orgLayout';
import { PlayersPage } from '../../pages/players/playersPage';
import { ListTeamsPage } from '../pages/listTeams/listTeams.page';
import { UserPage } from '../../pages/user/user.page';
import { UserForm } from '../../pages/user/user.form';
import { Home } from '../pages/home/Home.page';
import { Resources } from '../../components/resources/resources';
import { CreateIncidentPage } from '../../pages/createIncident/createIncident.page';
import { ViewIncidentPage } from '../../pages/viewIncident/viewIncident.page';
import { TeamDetails } from '../pages/teamDetails/teamDetails.smart';
import { Notifications } from '../../pages/notifications/notifications';
import { AboutUsPage } from '../../pages/aboutUs/aboutUs.page';
import { ConcussionSixRsPage } from '../../pages/concussionAdvice/concussionSixRs.page';
import { ConcussionRecoveryPage } from '../../pages/concussionAdvice/concussionRecovery.page';
import { ConcussionReturnToLearnPage } from '../../pages/concussionAdvice/concussionReturnToLearn.page';
import { ConcussionReturnToPlayPage } from '../../pages/concussionAdvice/concussionReturnToPlay.page';
import { OrgIncidentsListPage } from '../../pages/incidentsList/orgIncidentsList.page';
import { PlayersPageQueryService } from '../../pages/players/playersPage.queryParam.service';
import { di } from '../../state/inversify.config';
import { ConneqtPageQueryService } from '../../pages/conneqt/conneqt.queryParam.service';
import { AllOrgConneqts } from '../../pages/conneqt/allConneqtRequests/allOrgConneqts.smart';
import { ConneqtPage } from '../../pages/conneqt/conneqtPage';
import { ConneqtSubRoutes } from '../../pages/conneqt/conneqtSubRoutes';
import { SentRequests } from '../../pages/conneqt/sent/sentRequests.smart';
import { Pages } from '../../state/queryParams/pageQueries.slice';
import { CreateSymptomAssessment } from '../../pages/symptomAssessment/createSymptomAssessment';

const playersPageQueryService = di.get(PlayersPageQueryService);
const conneqtPageQueryService = di.get(ConneqtPageQueryService);

export const orgRoutes = {
  path: 'org',
  element: <OrgLayout />,
  // TODO: lazy load each app https://reactrouter.com/en/main/route/route
  // lazy={() => import("./a")}
  children: [
    {
      // TODO: figure out how to set sub route defaults
      index: true,
      element: <Home />,
    },
    // PLAYERS
    {
      path: 'players',
      element: <PlayersPage pageQuery={playersPageQueryService} />,
    },
    {
      path: 'player-profile',
      element: <PlayerProfilePage />,
    },
    // TEAM
    {
      path: 'teams',
      element: <ListTeamsPage />,
    },
    {
      path: 'team-details',
      element: <TeamDetails />,
    },
    // INCIDENT
    {
      path: 'view-incident',
      element: <ViewIncidentPage />,
    },
    {
      path: 'create-incident',
      element: <CreateIncidentPage />,
    },
    {
      path: 'incidents-list',
      element: <OrgIncidentsListPage />,
    },
    // SYMPTOM ASSESSMENT
    {
      path: 'create-symptom-check',
      element: <CreateSymptomAssessment />,
    },
    // RESOURCES
    {
      path: 'resources',
      element: <Resources />,
    },
    // CONNEQT
    {
      path: Pages.conneqt,
      element: (
        <ConneqtPage
          pageQueryParam={conneqtPageQueryService}
          showReceived={false}
        />
      ),
      children: [
        {
          index: true,
          element: <Navigate to={`${ConneqtSubRoutes.sent}`} replace />,
          // when user navigate to /conneqt it automatically navigate to /conneqt/sent
        },
        {
          path: ConneqtSubRoutes.all,
          element: <AllOrgConneqts pageQueryParam={conneqtPageQueryService} />,
        },
        {
          path: ConneqtSubRoutes.sent,
          element: <SentRequests pageQueryParam={conneqtPageQueryService} />,
        },
      ],
    },
    // USER
    {
      path: 'user',
      element: <UserPage />,
      children: [
        {
          path: 'create',
          element: <UserForm mode="create" />,
        },
        {
          path: 'edit',
          element: <UserForm mode="edit" />,
        },
      ],
    },
    {
      path: 'notifications',
      element: <Notifications />,
    },
    {
      path: 'about-us',
      element: <AboutUsPage />,
    },
    {
      path: 'concussion-6rs',
      element: <ConcussionSixRsPage />,
    },
    {
      path: 'concussion-recovery',
      element: <ConcussionRecoveryPage />,
    },
    {
      path: 'concussion-return-to-learn',
      element: <ConcussionReturnToLearnPage />,
    },
    {
      path: 'concussion-return-to-play',
      element: <ConcussionReturnToPlayPage />,
    },
  ],
};
